import { useState, useEffect } from "react";

function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
  <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-6 bg-[#140D4F] border border-[#0f0a3c] text-white rounded-xl p-4 shadow-2xl flex flex-col md:flex-row items-center justify-between gap-4 z-50">
    <p className="text-sm text-gray-200 leading-snug">
      🍪 We use cookies to improve your experience and ensure secure diagnostics.
      By using DiagCode.AI, you agree to our cookie policy.
    </p>
    <button
      onClick={acceptCookies}
      className="px-5 py-2 bg-[#FD5003] hover:bg-[#e34700] transition rounded-md font-semibold text-sm text-white"
    >
      Accept & Continue
    </button>
  </div>
);
}

export default CookieNotice;
